import { defineComponent, PropType } from "vue";

import { IDisplayDiagnosis } from "../../../../../../resources-vue/vue-interfaces/i-diagnosis";
import { IPastDiagnosis } from "../../../../../../resources-vue/vue-interfaces/i-health";
import { IPageCallbackResult } from "../../../../../../resources-vue/vue-interfaces/i-page-container";

import TableEmpty from "../../../../../../resources-vue/vue-custom-elements/TableEmpty/TableEmpty.vue";
import PastDiagnosisRow from "../PastDiagnosisRow/PastDiagnosisRow.vue";
import Pagination from "../../../../../../resources-vue/vue-elements/Pagination/Pagination.vue";

export default defineComponent({
    components: {
        TableEmpty,
        PastDiagnosisRow,
        Pagination
    },

    props: {
        diagnosis: {
            type: Array as PropType<IDisplayDiagnosis[]>,
            default: null
        },

        pageLimit: {
            type: Number,
            default: 5
        }
    },
    data() {
        return {
            newDiagnosis: [] as IDisplayDiagnosis[],
            isNewTerminal: false as boolean,
            columns: 5 as number,
            paginationInstance: null,
            currentPage: 1 as number,
            currentPageItems: [] as IDisplayDiagnosis[],
            isLoading: false as boolean,
            isAddRequested: true as boolean
        };
    },

    emits: ["update:diagnosis"],

    created() {
        this.paginationInstance = this.$refs.paginationInstance;
    },
    mounted() {
        this.paginationInstance = this.$refs.paginationInstance;
        this.paginationInstance.reset();
    },

    methods: {
        addDiagnosis() {
            if (this.diagnosis.length == 0) {
                this.isNewTerminal = true;
            } else {
                this.isNewTerminal = false;
            }
            this.newDiagnosis.push({
                code: "",
                description: "",
                order: null,
                isRelated: null,
                notRelatedComments: null,
                startDate: null,
                resolvedDate: null,
                billable: null,
                isStartDateUnknown: false,
                isResolvedDateUnknown: false,
                resolvedOrder: null
            });
            this.isAddRequested = true;
        },

        cancelEditDiagChanges(diag: any, changeIndex: number) {
            const temp = this.diagnosis.map((diagnosis: any, index: number) => {
                if (index === changeIndex) {
                    return diag;
                } else {
                    return diagnosis;
                }
            });
            this.$emit("update:diagnosis", temp);
        },

        deleteDiagnosis(index: number) {
            this.diagnosis.splice(index, 1);
            const temp = this.diagnosis.map((diagnosis: IDisplayDiagnosis | IPastDiagnosis, diagnosisIndex) => {
                if (!diagnosis.resolvedDate) {
                    diagnosis.order = diagnosisIndex + 1;
                }
                if ("resolvedOrder" in diagnosis) {
                    diagnosis.resolvedOrder = diagnosisIndex + 1;
                }
                return diagnosis;
            });
            this.$emit("update:diagnosis", temp);
            this.paginationInstance?.reset();
        },
        moveDiagnosis(oldIndex: number, newIndex: number) {
            let arr = [...this.diagnosis];
            if (oldIndex >= arr.length || oldIndex < 0) {
                return;
            }
            if (newIndex >= arr.length || newIndex < 0) {
                return;
            }
            arr.splice(newIndex, 0, arr.splice(oldIndex, 1)[0]);
            arr = arr.map((diagnosis: IDisplayDiagnosis | IPastDiagnosis, index) => {
                if (!diagnosis.resolvedDate) {
                    diagnosis.order = index + 1;
                }
                if ("resolvedOrder" in diagnosis) {
                    diagnosis.resolvedOrder = index + 1;
                }
                return diagnosis;
            });
            this.$emit("update:diagnosis", arr);
            this.paginationInstance?.reset();
        },
        saveNewDiagnosis(index: number) {
            let arr = [...this.diagnosis];
            const newDiagnosisCopy = [...this.newDiagnosis];
            newDiagnosisCopy[index].order = this.diagnosis.length + 1;
            (newDiagnosisCopy[index] as IPastDiagnosis).resolvedOrder = this.diagnosis.length + 1;
            arr.push(newDiagnosisCopy[index]);
            this.$emit("update:diagnosis", arr);
            this.paginationInstance?.reset();
            this.newDiagnosis.splice(index, 1);
        },
        cancelSaveNewDiagnosis(index: number) {
            this.newDiagnosis.splice(index, 1);
        },

        async pageChangedCallback(pageNumber: number): Promise<IPageCallbackResult> {
            this.currentPage = pageNumber;
            if (this.diagnosis?.length > 0) {
                let endIndex = this.pageLimit * this.currentPage;
                let startIndex = endIndex - this.pageLimit;
                if (endIndex > this.diagnosis.length) {
                    endIndex = this.diagnosis.length;
                }
                if (startIndex < 0) {
                    startIndex = 0;
                }
                this.currentPageItems = this.diagnosis.slice(startIndex, endIndex);
            } else {
                this.currentPageItems = [];
            }
            if (this.currentPageItems.length === 0 && this.diagnosis.length > 0) {
                this.paginationInstance.decrementPageNumber();
            }
            return {
                totalPageCount: this.diagnosis.length < this.pageLimit ? 1 : Math.ceil(this.diagnosis.length),
                success: true,
                totalCount: this.diagnosis.length
            };
        }
    }
});
